// Modo de operación del backoffice: 'retail' (default) | 'cafeteria'.
// Cambia qué muestra el sidebar (retail completo vs. solo cafetería). Persistente.
const KEY = 'appMode';

export function getAppMode() {
    return localStorage.getItem(KEY) === 'cafeteria' ? 'cafeteria' : 'retail';
}

export function setAppMode(mode) {
    localStorage.setItem(KEY, mode === 'cafeteria' ? 'cafeteria' : 'retail');
}

export function isCafeteriaMode() {
    return getAppMode() === 'cafeteria';
}

// El home de cada modo. Es la ÚNICA definición: la usa la vuelta al terminar una tarea, y la
// van a usar el login y el selector de modo cuando el home deje de estar en prueba (hoy se
// entra sólo por URL, y el login sigue aterrizando en /purchase). `homePageURL` no sirve para esto último — finanzas guarda ahí
// `/invoices`, y queda viejo si alguien cambia de modo después de loguearse.
export function homeDelModo() {
    return isCafeteriaMode() ? '/cafeteriaHome' : '/home';
}

// ── Volver al home al terminar ──────────────────────────────────────────────
//
// Las tareas que se ABREN desde el home (nueva venta, abrir caja, vender en la puerta, nueva
// comanda) vuelven al home cuando terminan. Las mismas pantallas abiertas desde el sidebar
// siguen yendo a su listado de siempre: si estás trabajando en Ventas, volver al home te saca
// de lo que estabas haciendo. La marca es explícita en la URL (`desde=home`) y no un estado
// escondido, así una pantalla abierta en otra pestaña no hereda la vuelta.

export function conVueltaAlHome(ruta) {
    return `${ruta}${ruta.includes('?') ? '&' : '?'}desde=home`;
}

// Leerlo UNA vez al montar y guardarlo: varias pantallas reescriben su propia URL (Anotados
// saca `vender=1`, la consulta de precio limpia `q`) y el `desde` se perdería con ella.
export function vinoDelHome(search) {
    return new URLSearchParams(search || '').get('desde') === 'home';
}

export function destinoAlTerminar(desdeHome, rutaDeSiempre) {
    return desdeHome ? homeDelModo() : rutaDeSiempre;
}
